import { EmailCampaignWildcards } from '@televet/shared-types/emailCampaignEmailSendJobs/types/EmailCampaignWildcards';

export interface WildcardValidationCheckResponse { invalid: boolean; results: { title: string; description: string; }[]; }

export const containsInvalidWildcards = (
  html?: string | null,
): WildcardValidationCheckResponse => {
  if (!html) {
    return {
      invalid: false,
      results: [
        {
          title: '',
          description: '',
        },
      ],
    };
  }

  const validationResults: WildcardValidationCheckResponse = {
    invalid: false,
    results: [],
  };
  const brackets = html?.match(/}|{/gm) ?? [];
  const unevenBrackets = brackets.length % 2 !== 0;

  if (unevenBrackets) {
    console.log({brackets, unevenBrackets});
    validationResults.invalid = true;
    validationResults.results.push({
      title: 'Wildcards are not formatted correctly',
      description: 'Wildcards must be contained within curly brackets, like this: {{clientName}}',
    });
  }

  if (brackets) {
    const wildcards = html.match(/(?<={{)(.*?)(?=}})/gm) ?? [];
    wildcards.forEach((wildcard) => {
      if (!(wildcard in EmailCampaignWildcards)) {
        console.log({invalidWildcard: wildcard});
        validationResults.invalid = true;
        validationResults.results.push({
          title: `${wildcard} is not a valid wildcard`,
          description: `Please use the following: {{clientName}}`,
        });
      }
    });
  }

  return validationResults;
};
